import { Component } from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslationService} from '../../core/services/translation/translation.service';
import {NgClickOutsideDirective} from 'ng-click-outside2';

@Component({
  selector: 'app-language-switcher',
  imports: [
    CommonModule,
    NgClickOutsideDirective
  ],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss'
})
export class LanguageSwitcherComponent {
  iconLanguage: string;
  currentLang: string;
  langDropdownOpen: boolean = false;

  constructor(
    private readonly translationService: TranslationService,
  ) {
    const currentLanguageObject = this.translationService.getCurrentLangObj();
    this.currentLang = currentLanguageObject.id;
    this.iconLanguage = currentLanguageObject.iconName;
  }

  onClickedOutsideLang(e: Event) {
    this.langDropdownOpen = false
  }

  switchLanguage(lang: string): void {
    if (!this.translationService.isLanguageAvailable(lang)) {
      return;
    }
    this.translationService.setLanguage(lang);

    const currentLanguageObject = this.translationService.getCurrentLangObj();
    this.currentLang = currentLanguageObject.id;
    this.iconLanguage = currentLanguageObject.iconName;
    this.langDropdownOpen = false; // Close the dropdown after selecting a language
  }

  getAvailableLanguages() {
    return this.translationService.getAvailableLanguages();
  }
}
